const STORAGE_KEY = 'tla_unit_pref';
const VALID_UNITS = new Set(['km', 'mi']);

export function getUnitPreference() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return VALID_UNITS.has(value) ? value : 'km';
  } catch {
    return 'km';
  }
}

export function setUnitPreference(unit) {
  if (!VALID_UNITS.has(unit)) return;
  try {
    localStorage.setItem(STORAGE_KEY, unit);
  } catch {
    // ignore quota / private mode
  }
}
